import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import FeatureSection from './components/FeatureSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <FeatureSection />
      <CategoryGrid />
      <ArticleSection />
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'VigorBuy Spreadsheet Guide',
            url: 'https://vigorbuyspread.living',
            description:
              'The trusted knowledge hub for VigorBuy Spreadsheet users. Complete guides, reviews, templates, security resources, and expert comparisons.',
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
    </main>
  );
}